import { render, staticRenderFns } from "./SucceedOne.vue?vue&type=template&id=48fac3e9&scoped=true"
import script from "./SucceedOne.vue?vue&type=script&lang=js"
export * from "./SucceedOne.vue?vue&type=script&lang=js"
import style0 from "./SucceedOne.vue?vue&type=style&index=0&id=48fac3e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fac3e9",
  null
  
)

export default component.exports